const responsiveProps = (props, addAtSymbol, ...variantNames) => {
  const mapped = variantNames.reduce((res, variantName) => {
    const getNewValue = (value2) => `${"@"}${value2}`;
    const value = props[variantName];
    if (typeof value !== "object") return res;
    const bps = Object.keys(value);
    const { base, medium, large, ...out } = value;
    res[variantName] = out;
    if (medium !== void 0) {
      out[getNewValue("baseToMedium")] = base;
      out[bps.includes("large") ? getNewValue("mediumToLarge") : getNewValue("medium")] = medium;
    } else out[bps.includes("large") ? getNewValue("baseToLarge") : getNewValue("base")] = base;
    if (large !== void 0) out[getNewValue("large")] = large;
    return res;
  }, {});
  return { ...props, ...mapped };
};
export {
  responsiveProps as default,
  responsiveProps
};
//# sourceMappingURL=responsiveProps.es.js.map
